import { JSONSchemaType } from 'ajv'

export interface IEmailLogFormData {
  id: string
  emailSentTo: string
  emailSentAt: string
  title: string
  body: string
}

const EmailLogSchema: JSONSchemaType<IEmailLogFormData> = {
  type: 'object',
  properties: {
    emailSentTo: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    title: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    body: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    emailSentAt: {
      type: 'string',
    },
    id: {
      type: 'string',
    },
  },
  required: ['emailSentTo', 'title', 'body'],
  additionalProperties: false,
}

export default EmailLogSchema
